import { useMemo } from 'react';
import { Column } from '~/commonComponents';
import { IDraftJobPostEntity } from '~/domain/PermanentJobs';
import { UserProfession, UserSubProfession } from '~/enums/UserProfession';
import { EducationUtils } from '~/utils/EducationUtils';
import { EnumHelper } from '~/utils/EnumHelper';
import { InfoSection } from '../InfoSection';
import { LabelValueDisplay } from '../LabelValueDisplay';

interface IBasicInfoPreviewProps {
  jobPosting: IDraftJobPostEntity;
  onEditClick: () => void;
}

export const BasicInfoPreview = ({ jobPosting, onEditClick }: IBasicInfoPreviewProps) => {
  const fmtProfessionalType = useMemo(() => {
    const profToDisplay = jobPosting.subProfession || jobPosting.professionType;
    if (!profToDisplay) return '';

    const isSubProfession = EnumHelper.getObjectKeys(UserSubProfession).includes(profToDisplay);
    return isSubProfession
      ? UserSubProfession.getName(profToDisplay)
      : UserProfession.getName(profToDisplay);
  }, [jobPosting.professionType, jobPosting.subProfession]);

  return (
    <InfoSection
      icon="briefcase-solid"
      rightActionIcon="edit-pencil"
      title="General Job Information"
      onRightActionPress={onEditClick}
    >
      <Column gap={14}>
        <LabelValueDisplay label="Office Name" value={jobPosting.officeName} />
        <LabelValueDisplay label="Job Title" value={jobPosting.title} />
        <LabelValueDisplay label="Professional Type" value={fmtProfessionalType} />
        <LabelValueDisplay
          label="Specialty"
          value={EducationUtils.removeSpecialtyPrefix(jobPosting.officeSpecialty || '')}
        />
      </Column>
    </InfoSection>
  );
};
